// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__14z6L","boxTitle":"Qualiphy_boxTitle__hp4PX","box":"Qualiphy_box__2y1m6","toggleWrap":"Qualiphy_toggleWrap__3_LMX"};